import React from "react";
import "./BananinhaMobile.css";
import logo from "../../../assets/bananinha/logo-bananinha.png";
import nutricional from "../../../assets/bananinha/nutricional-bananinha.png"
import produto from "../../../assets/bananinha/produto-bananinha.png"
//@ts-ignore
import Pulse from 'react-reveal/Pulse';
export default function BananinhaMobile() {
  return (
    <div className="container-bananinha-mobile">
      <div className="content-group-wrapper-bananinha-mobile">
        <div className="content-group-container-bananinha-mobile">

          <div className="title-group-container-bananinha-mobile">
            <div className="title-container-bananinha-mobile">
              <p className="title-bananinha-mobile">Bananinha Zero</p>
              <p className="title2-bananinha-mobile">adição de açúcar</p>
            </div>
            <div className="title-container2-bananinha-mobile">
              <p className="title3-bananinha-mobile">
                É fruta de verdade com sabor natural.
              </p>
            </div>
          </div>
          <div className="logo-img-container-bananinha-mobile">
            <img src={logo} width="90px" height="67px"></img>
          </div>
        </div>
        <div className="content-group2-container-bananinha-mobile">
        <div className="about-bananinha-mobile">
        <p className="about-title-bananinha-mobile">Nosso produto é:</p>
        <div className="about-text-container-bananinha-mobile">  
        <p className="about-text-bananinha-mobile">• Sem glúten</p>
        <p className="about-text-bananinha-mobile">• Sem adição de açúcar</p>  
        <p className="about-text-bananinha-mobile">• Sem adição de adoçantes</p>  
        <p className="about-text-bananinha-mobile">• Sem flavorizantes e corantes</p>
        <p className="about-text-bananinha-mobile">• Produto vegano</p>
        <p className="about-text-bananinha-mobile">• Sem colesterol</p> 
        </div>         
        </div>

        </div>
        <Pulse delay={200}>
        <div className="content-group3-container-bananinha-mobile">
      
        
        <div className="produto-nutricional-img-container-bananinha-mobile">

            <img src={produto} className="produto-nutricional-img-bananinha-mobile" />

 
        </div>


        
        </div>
        </Pulse>

      </div>
    </div>
  );
}
